module.exports = __webpack_public_path__ + "static/media/game_over.1f9b30c9.wav";